const endpoints = Object.freeze({
'ALL_EVENTS':"/event/all",
'FEATURED_EVENTS':"/event/management/all-featured-events",
'UPCOMING_EVENTS': "/event/upcoming",
'HERO_EVENT':"/hero/get-hero",
'RSVP':'/tickets/rsvp?deviceType=web'
})

export default endpoints;